
import UserPlantsMap from './UserPlantsMap';
import CurrentObservationMap from './CurrentObservationMap';
import DeleteObservation from './DeleteObservation';

Vue.component('user-plants-map', UserPlantsMap);
Vue.component('current-observation-map', CurrentObservationMap);
Vue.component('delete-observation', DeleteObservation);

const app = new Vue({
  components: {
    CurrentObservationMap,
    UserPlantsMap,
    DeleteObservation,
  }
}).$mount('#app');
